/* strip trailing zeros from a money string: $5.00 -> $5, $2.60 -> $2.6 */
function roseClStripZeros(str) {
  if (!str || str.indexOf('.') === -1) return str;
  return str.replace(/0+$/, '').replace(/\.$/, '');
}
/* filename of an image URL, minus query string - used to match a variant image to a gallery slide */
function roseClBase(u) { return String(u || '').split('?')[0].split('/').pop(); }
/* format cents -> "$1,234.56" (matches Shopify's default money filter; tiles keep the .00) */
function roseClMoney(cents, hideZeros) {
  var n = (Number(cents) || 0) / 100;
  var dec = (hideZeros && n === Math.round(n)) ? 0 : 2;  // match money_without_trailing_zeros
  var parts = n.toFixed(dec).split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return '$' + parts.join('.');
}
/* ============================================================
   Rose: classic (white) system - buy box, evergreen countdown,
   before/after slider. Standalone. Each element guarded.
   ============================================================ */

/* ---- Buy box: 1- or 2-option resolution, live price, optional bundle ---- */
if (!customElements.get('rose-cl-buy')) {
  customElements.define('rose-cl-buy', class extends HTMLElement {
    connectedCallback() {
      var el = this.querySelector('script[data-cl-variants]');
      try { this.variants = el ? JSON.parse(el.textContent) : []; } catch (e) { this.variants = []; }
      this.optName = this.querySelector('[data-cl-opt-name]');
      this.opt2Name = this.querySelector('[data-cl-opt2-name]');
      this.priceEl = this.querySelector('[data-cl-price]');
      this.compareEl = this.querySelector('[data-cl-compare]');
      this.perRoseEl = this.querySelector('[data-cl-perrose]');
      this.idInput = this.querySelector('[data-cl-id]');
      this.qtyInput = this.querySelector('[data-cl-qty]');
      this.itemsBox = this.querySelector('[data-cl-items]');
      this.unitsBox = this.querySelector('[data-cl-units]');
      this.unitSelects = Array.from(this.querySelectorAll('[data-cl-unit]'));
      this.form = this.querySelector('form');
      this.atc = this.querySelector('[data-cl-atc]');
      this.atcLabel = this.querySelector('[data-cl-atc-label]');
      this.atcText = this.atcLabel ? this.atcLabel.textContent.trim() : 'Add to Cart';
      this.forceAvail = this.hasAttribute('data-cl-force-avail');
      this.expressSingleOnly = this.hasAttribute('data-cl-express-single');
      this.hideCents = this.hasAttribute('data-cl-hidecents');
      this.mixExclude = this.getAttribute('data-cl-mix-exclude') || '';
      this.dynamic = this.querySelector('[data-cl-dynamic]');
      this.activeQty = this.qtyInput ? parseInt(this.qtyInput.value, 10) || 1 : 1;

      // current option values from the active controls (fall back to first variant)
      var a1 = this.querySelector('[data-cl-opt1].is-active');
      var a2 = this.querySelector('[data-cl-opt2].is-active');
      this.o1 = a1 ? a1.dataset.value : (this.variants[0] ? this.variants[0].o1 : null);
      this.o2 = a2 ? a2.dataset.value : (this.variants[0] ? this.variants[0].o2 : null);

      // Honor an incoming ?variant=<id> deep link (e.g. collection color links) so it preselects.
      try {
        var urlV = new URLSearchParams(location.search).get('variant');
        if (urlV) {
          for (var uv = 0; uv < this.variants.length; uv++) {
            if (String(this.variants[uv].id) === String(urlV)) {
              this.o1 = this.variants[uv].o1; this.o2 = this.variants[uv].o2;
              this.syncOptActive();
              break;
            }
          }
        }
      } catch (e) {}

      this.bindOpt('[data-cl-opt1]', 'o1');
      this.bindOpt('[data-cl-opt2]', 'o2');
      this.initGallery();
      this.bindTiles();
      this.bindUnits();
      this.bundleOv = this.parseBundleOv();
      this.captureTileDefaults();
      this.updateVariant();
    }
    resolve() {
      var self = this;
      for (var i = 0; i < this.variants.length; i++) {
        var v = this.variants[i];
        if (v.o1 === self.o1 && (v.o2 == null || v.o2 === self.o2)) return v;
      }
      return this.variants[0] || null;
    }
    bindOpt(sel, key) {
      var self = this;
      this.querySelectorAll(sel).forEach(function (b) {
        b.addEventListener('click', function () {
          if (b.disabled) return;
          self.interacted = true;
          self[key] = b.dataset.value;
          self.querySelectorAll(sel).forEach(function (x) {
            var on = x.dataset.value === self[key];
            x.classList.toggle('is-active', on); x.setAttribute('aria-checked', on ? 'true' : 'false');
          });
          self.updateVariant();
        });
      });
    }
    updateVariant() {
      var v = this.resolve(); if (!v) return;
      this.current = v;
      if (this.optName) this.optName.textContent = v.o1;
      if (this.opt2Name && v.o2 != null) this.opt2Name.textContent = v.o2;
      if (this.priceEl && v.price) this.priceEl.textContent = v.price;
      if (this.compareEl) { if (v.compare) { this.compareEl.textContent = v.compare; this.compareEl.hidden = false; } else { this.compareEl.hidden = true; } }
      if (this.perRoseEl) { if (v.perRose) { this.perRoseEl.textContent = '(' + roseClStripZeros(v.perRose) + ' per rose)'; this.perRoseEl.hidden = false; } else { this.perRoseEl.hidden = true; } }
      if (v.image) this.galleryKey(v.image);
      var ok = this.forceAvail ? true : !!v.available;
      if (this.atc) { this.atc.disabled = !ok; if (this.atcLabel) this.atcLabel.textContent = ok ? this.atcText : 'Sold out'; }
      this.renderTiles(v);
      this.applyTile(this.activeQty);
      this.syncUrl(v);
    }
    // Reflect the chosen variant in the address bar (?variant=<id>), no history spam.
    // Only AFTER the first user interaction - a clean landing (e.g. /products/lamp) stays clean,
    // exactly like a native Shopify product page, so ad clicks never see an instant redirect.
    syncUrl(v) {
      if (!this.interacted) return;
      if (!v || v.id == null) return;
      try {
        var url = new URL(location.href);
        if (url.searchParams.get('variant') === String(v.id)) return;
        url.searchParams.set('variant', String(v.id));
        history.replaceState(history.state, '', url.toString());
      } catch (e) {}
    }
    // Sync the option buttons' active state to the current o1/o2 (used for deep-link preselect).
    syncOptActive() {
      var self = this;
      [['[data-cl-opt1]', 'o1'], ['[data-cl-opt2]', 'o2']].forEach(function (pair) {
        self.querySelectorAll(pair[0]).forEach(function (x) {
          var on = x.dataset.value === self[pair[1]];
          x.classList.toggle('is-active', on); x.setAttribute('aria-checked', on ? 'true' : 'false');
        });
      });
    }
    // Parse the per-variant tile overrides: "Variant | tile# | price | suffix | compare | label | benefit"
    parseBundleOv() {
      var el = this.querySelector('[data-cl-bundle-ov]');
      var map = {};
      if (!el) return map;
      (el.textContent || '').split('\n').forEach(function (line) {
        line = line.trim(); if (!line) return;
        var p = line.split('|');
        if (p.length < 3) return;
        var key = (p[0] || '').trim().toLowerCase();
        var tile = (p[1] || '').trim();
        if (!key || !tile) return;
        if (!map[key]) map[key] = {};
        map[key][tile] = {
          price:   (p[2] || '').trim(),
          suffix:  (p[3] || '').trim(),
          compare: (p[4] || '').trim(),
          label:   (p[5] || '').trim(),
          benefit: (p[6] || '').trim()
        };
      });
      return map;
    }
    captureTileDefaults() {
      this.querySelectorAll('[data-cl-tile]').forEach(function (tile) {
        var lab = tile.querySelector('.rose-cl__tile-label');
        var ben = tile.querySelector('.rose-cl__tile-caption');
        tile._defLabel = lab ? lab.textContent : '';
        tile._defBenefit = ben ? ben.textContent : null;
      });
    }
    /* Render each bundle tile for the selected variant, in priority order:
       1) a per-variant override (matched on variant title or color),
       2) the tile's own default custom price, else
       3) the computed live price (mirrors rose-bundle-price.liquid). */
    renderTiles(v) {
      var self = this;
      var ov = this.bundleOv || {};
      var keys = [];
      if (v) {
        if (v.title) keys.push(String(v.title).trim().toLowerCase());
        if (v.o1) keys.push(String(v.o1).trim().toLowerCase());
      }
      this.querySelectorAll('[data-cl-tile]').forEach(function (tile) {
        var box = tile.querySelector('.rose-cl__tile-price'); if (!box) return;
        var tnum = tile.dataset.tile || '';
        var o = null;
        for (var k = 0; k < keys.length; k++) { if (ov[keys[k]] && ov[keys[k]][tnum]) { o = ov[keys[k]][tnum]; break; } }

        // Label / benefit - use the override, otherwise restore the default.
        var lab = tile.querySelector('.rose-cl__tile-label');
        var ben = tile.querySelector('.rose-cl__tile-caption');
        if (lab && tile._defLabel != null) lab.textContent = (o && o.label) ? o.label : tile._defLabel;
        if (ben && tile._defBenefit != null) ben.textContent = (o && o.benefit) ? o.benefit : tile._defBenefit;

        // Price: override wins, then the tile's own custom price, then computed.
        var price = '', suffix = '', compare = '';
        if (o && o.price) { price = o.price; suffix = o.suffix; compare = o.compare; }
        else if (tile.dataset.clPrice) { price = tile.dataset.clPrice; suffix = tile.dataset.clSuffix || ''; compare = tile.dataset.clCompare || ''; }

        if (price) {
          var html = '<span class="quantity-break__price">' + price + (suffix ? '<span class="rose-price-each">' + suffix + '</span>' : '') + '</span>';
          if (compare) html += '<span class="quantity-break__compare-price">' + compare + '</span>';
          box.innerHTML = html;
          return;
        }
        // Computed live price
        if (v && v.priceCents != null) {
          var unit = Number(v.priceCents) || 0, cmp = Number(v.compareCents) || 0;
          var qty = parseInt(tile.dataset.qty, 10) || 1;
          // Rows style: show the TOTAL (qty x native unit) + native total compare, auto SAVE pill.
          if (tile.dataset.clTotal) {
            var baseEach = cmp > unit ? cmp : unit;
            var total = Math.round(unit * qty);
            var totalWas = Math.round(baseEach * qty);
            var ht = '<span class="quantity-break__price">' + roseClMoney(total, self.hideCents) + '</span>';
            if (totalWas > total) ht += '<span class="quantity-break__compare-price">' + roseClMoney(totalWas, self.hideCents) + '</span>';
            box.innerHTML = ht;
            var sp = tile.querySelector('[data-cl-save]');
            if (sp) {
              var sv = totalWas - total;
              if (sv > 0) { sp.textContent = 'SAVE ' + roseClMoney(sv, self.hideCents); sp.hidden = false; }
              else { sp.hidden = true; }
            }
            return;
          }
          var each = Math.round(unit);                    // per-unit = the unit price at qty>1
          var eachWas = Math.round((cmp > unit ? cmp : unit));
          var html2 = '<span class="quantity-break__price">' + roseClMoney(each) + (qty > 1 ? '<span class="rose-price-each">/ea</span>' : '') + '</span>';
          if (qty === 1) { if (eachWas > each) html2 += '<span class="quantity-break__compare-price">' + roseClMoney(eachWas) + '</span>'; }
          else if (tile.dataset.compareEach && eachWas > each) html2 += '<span class="quantity-break__compare-price">' + roseClMoney(eachWas) + '</span>';
          box.innerHTML = html2;
        }
      });
    }
    /* ---- Swipeable gallery: dots, transparent arrows, drag/swipe ---- */
    initGallery() {
      var self = this;
      this.gTrack = this.querySelector('[data-cl-slides]');
      this.gViewport = this.querySelector('[data-cl-gallery]');
      this.gSlides = this.gTrack ? Array.from(this.gTrack.querySelectorAll('[data-cl-slide-img]')) : [];
      this.gDots = Array.from(this.querySelectorAll('[data-cl-dot]'));
      if (!this.gTrack || this.gSlides.length === 0) return;
      this.gKeys = this.gSlides.map(function (im) { return roseClBase(im.getAttribute('src')); });
      // initial index = the active dot the server marked, else 0
      this.gIndex = Math.max(0, this.gDots.findIndex(function (d) { return d.classList.contains('is-active'); }));
      if (this.gIndex < 0) this.gIndex = 0;

      var prev = this.querySelector('[data-cl-prev]');
      var next = this.querySelector('[data-cl-next]');
      if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); self.galleryGo(self.gIndex - 1); });
      if (next) next.addEventListener('click', function (e) { e.preventDefault(); self.galleryGo(self.gIndex + 1); });
      this.gDots.forEach(function (d, i) { d.addEventListener('click', function () { self.galleryGo(i); }); });

      // Pointer drag / swipe
      if (this.gSlides.length > 1) {
        var dragging = false, startX = 0, dx = 0, w = 0;
        var down = function (e) {
          if (e.target.closest('[data-cl-prev],[data-cl-next],[data-cl-dot]')) return;
          dragging = true; startX = e.clientX; dx = 0; w = self.gViewport.offsetWidth || 1;
          self.gTrack.style.transition = 'none';
        };
        var move = function (e) {
          if (!dragging) return;
          dx = e.clientX - startX;
          self.gTrack.style.transform = 'translateX(calc(' + (-self.gIndex * 100) + '% + ' + dx + 'px))';
        };
        var up = function () {
          if (!dragging) return;
          dragging = false;
          self.gTrack.style.transition = '';
          if (dx < -w * 0.15) self.galleryGo(self.gIndex + 1);
          else if (dx > w * 0.15) self.galleryGo(self.gIndex - 1);
          else self.galleryGo(self.gIndex);
        };
        this.gViewport.addEventListener('pointerdown', down);
        this.gViewport.addEventListener('pointermove', move);
        this.gViewport.addEventListener('pointerup', up);
        this.gViewport.addEventListener('pointercancel', up);
        this.gViewport.addEventListener('pointerleave', up);
        // don't let the browser start an image drag
        this.gViewport.addEventListener('dragstart', function (e) { e.preventDefault(); });
      }
    }
    galleryGo(i) {
      if (!this.gTrack || !this.gSlides.length) return;
      var n = this.gSlides.length;
      i = ((i % n) + n) % n;           // wrap around
      this.gIndex = i;
      this.gTrack.style.transform = 'translateX(-' + (i * 100) + '%)';
      this.gDots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    galleryKey(url) {
      if (!this.gKeys || !this.gKeys.length) return;
      var base = roseClBase(url);
      var idx = this.gKeys.indexOf(base);
      if (idx > -1) this.galleryGo(idx);
    }
    bindTiles() {
      var self = this;
      this.querySelectorAll('[data-cl-tile]').forEach(function (tile) {
        tile.addEventListener('click', function () {
          self.querySelectorAll('[data-cl-tile]').forEach(function (t) { t.classList.toggle('is-active', t === tile); });
          var r = tile.querySelector('input[type=radio]'); if (r) r.checked = true;
          self.applyTile(parseInt(tile.dataset.qty, 10) || 1);
        });
      });
    }
    applyTile(qty) {
      this.activeQty = qty;
      var multi = qty > 1;
      var cur = this.current || this.resolve();
      // When the main variant is the "excluded" one (e.g. lamp Multi-Color), there is no color-mixing:
      // the pickers stay hidden and the pack is just N of that variant.
      var excluded = this.mixExclude && cur && String(cur.o1) === this.mixExclude;
      var mixing = multi && this.unitSelects.length > 0 && !excluded;
      if (this.unitsBox) this.unitsBox.hidden = !mixing;
      // Hide the express/dynamic checkout when mixing (Shop Pay can't carry a mixed items[] bundle),
      // or on any multi-pack when the template opts into single-only express.
      if (this.dynamic) this.dynamic.hidden = mixing || (multi && this.expressSingleOnly);
      if (mixing) {
        // Show only as many per-unit pickers as the selected tile's quantity.
        this.unitSelects.forEach(function (s, i) {
          var row = s.closest('.rose-cl__unit');
          if (row) row.hidden = i >= qty;
          if (i < qty && !s.dataset.touched) s.value = String(cur.id);
        });
        this.rebuildItems();
      } else {
        if (this.itemsBox) { this.itemsBox.innerHTML = ''; this.itemsBox.hidden = true; }
        if (this.idInput && cur) this.idInput.value = String(cur.id);
        if (this.qtyInput) this.qtyInput.value = String(qty || 1);
      }
    }
    bindUnits() {
      var self = this;
      this.unitSelects.forEach(function (s) { s.addEventListener('change', function () { s.dataset.touched = '1'; self.rebuildItems(); }); });
    }
    rebuildItems() {
      if (!this.itemsBox || !this.idInput) return;
      var n = this.activeQty || this.unitSelects.length;
      var ids = this.unitSelects.slice(0, n).map(function (s) { return s.value; });
      var html = '';
      for (var i = 0; i < ids.length; i++) {
        html += '<input type="hidden" name="items[' + i + '][id]" value="' + ids[i] + '">';
        html += '<input type="hidden" name="items[' + i + '][quantity]" value="1">';
      }
      this.itemsBox.innerHTML = html; this.itemsBox.hidden = false;
      this.idInput.value = ids.join(',');
    }
  });
}

/* ---- Testimonial carousel: auto-scroll + arrows + swipe + click-to-expand ---- */
if (!customElements.get('rose-cl-quotes')) {
  customElements.define('rose-cl-quotes', class extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.track = this.querySelector('[data-cl-quotes-track]');
      this.viewport = this.querySelector('[data-cl-quotes-viewport]') || this;
      this.cards = this.track ? Array.from(this.track.querySelectorAll('[data-cl-quote-card]')) : [];
      if (!this.track || this.cards.length === 0) return;
      this.i = 0;
      this.go = this.go.bind(this);

      // Click / keyboard on a card opens the full review (unless it was a swipe)
      this.cards.forEach(function (card) {
        card.addEventListener('click', function () { if (!self.dragged) self.openModal(card); });
        card.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); self.openModal(card); } });
      });

      var prev = this.querySelector('[data-cl-quotes-prev]');
      var next = this.querySelector('[data-cl-quotes-next]');
      if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); self.go(self.i - 1); self.restart(); });
      if (next) next.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); self.go(self.i + 1); self.restart(); });

      if (this.cards.length > 1) {
        // Append a clone of the first card so the auto-scroll can run PAST the last
        // slide into a copy of the first, then snap back invisibly = a seamless loop
        // instead of rewinding all the way to the start.
        var clone = this.cards[0].cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('tabindex', '-1');
        clone.removeAttribute('data-cl-quote-card');
        clone.classList.add('rose-cl__quote--clone');
        this.track.appendChild(clone);

        this.bindSwipe();
        var secs = parseFloat(this.dataset.interval) || 5;
        this.ms = Math.max(2, secs) * 1000;
        this.start();
        this.addEventListener('mouseenter', function () { clearInterval(self.timer); });
        this.addEventListener('mouseleave', function () { self.start(); });
      }
    }
    start() { clearInterval(this.timer); if (this.cards.length > 1) this.timer = setInterval(this.go, this.ms); }
    restart() { this.start(); }
    go(i) {
      if (i == null) i = this.i + 1;                       // called bare by the timer
      var n = this.cards.length;                            // real cards; a clone of #0 sits at index n
      var self = this;
      if (i < 0) {
        // Seamless backward: jump (no anim) onto the trailing clone, then slide to the last real card.
        this.track.style.transition = 'none';
        this.track.style.transform = 'translateX(-' + (n * 100) + '%)';
        void this.track.offsetWidth;                        // force reflow so the next move animates
        this.track.style.transition = '';
        i = n - 1;
      } else if (i > n) {
        i = 1;
      }
      this.i = i;
      this.track.style.transform = 'translateX(-' + (i * 100) + '%)';
      if (i === n) {
        // Landed on the clone of the first card - after it slides in, snap back to the
        // real first card with no animation. Visually identical, so the loop is seamless.
        var snap = function () {
          self.track.removeEventListener('transitionend', snap);
          self.track.style.transition = 'none';
          self.i = 0;
          self.track.style.transform = 'translateX(0)';
          void self.track.offsetWidth;
          self.track.style.transition = '';
        };
        this.track.addEventListener('transitionend', snap);
      }
    }
    bindSwipe() {
      var self = this, dragging = false, startX = 0, dx = 0, w = 0;
      this.viewport.addEventListener('pointerdown', function (e) {
        if (e.target.closest('[data-cl-quotes-prev],[data-cl-quotes-next]')) return;
        dragging = true; self.dragged = false; startX = e.clientX; dx = 0;
        w = self.viewport.offsetWidth || 1; self.track.style.transition = 'none';
      });
      this.viewport.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        dx = e.clientX - startX;
        if (Math.abs(dx) > 6) self.dragged = true;
        self.track.style.transform = 'translateX(calc(' + (-self.i * 100) + '% + ' + dx + 'px))';
      });
      var end = function () {
        if (!dragging) return;
        dragging = false; self.track.style.transition = '';
        if (dx < -w * 0.15) self.go(self.i + 1);
        else if (dx > w * 0.15) self.go(self.i - 1);
        else self.go(self.i);
        self.restart();
        setTimeout(function () { self.dragged = false; }, 0);   // let the click handler read it first
      };
      this.viewport.addEventListener('pointerup', end);
      this.viewport.addEventListener('pointercancel', end);
      this.viewport.addEventListener('pointerleave', end);
    }
    openModal(card) {
      var self = this;
      if (!this.modal) {
        this.modal = document.createElement('div');
        this.modal.className = 'rose-cl__quote-modal';
        this.modal.hidden = true;
        this.modal.innerHTML = '<div class="rose-cl__quote-modal-overlay" data-cl-qm-close></div>' +
          '<div class="rose-cl__quote-modal-card" role="dialog" aria-modal="true">' +
          '<button type="button" class="rose-cl__quote-modal-x" data-cl-qm-close aria-label="Close">&times;</button>' +
          '<div class="rose-cl__quote-modal-body" data-cl-qm-body></div></div>';
        document.body.appendChild(this.modal);
        // Close on the X, or on any click that lands outside the white card.
        this.modal.addEventListener('click', function (e) {
          if (e.target.closest('.rose-cl__quote-modal-x') || !e.target.closest('.rose-cl__quote-modal-card')) self.closeModal();
        });
        this._esc = function (e) { if (e.key === 'Escape') self.closeModal(); };
      }
      this.modal.querySelector('[data-cl-qm-body]').innerHTML = card.innerHTML;
      this.modal.hidden = false;
      document.addEventListener('keydown', this._esc);
      document.documentElement.style.overflow = 'hidden';
    }
    closeModal() {
      if (!this.modal) return;
      this.modal.hidden = true;
      document.removeEventListener('keydown', this._esc);
      document.documentElement.style.overflow = '';
    }
    disconnectedCallback() { clearInterval(this.timer); if (this.modal) { this.closeModal(); this.modal.remove(); this.modal = null; } }
  });
}

/* ---- Evergreen countdown (localStorage, restarts at zero) ---- */
if (!customElements.get('rose-cl-countdown')) {
  customElements.define('rose-cl-countdown', class extends HTMLElement {
    connectedCallback() {
      // Evergreen duration = hours + minutes + seconds (0 is valid for each).
      var h = parseFloat(this.dataset.hours); if (isNaN(h)) h = 8;
      var m = parseFloat(this.dataset.minutes) || 0;
      var sec = parseFloat(this.dataset.seconds) || 0;
      this.span = ((h * 3600) + (m * 60) + sec) * 1000;
      if (this.span <= 0) this.span = 8 * 3600 * 1000;   // guard if everything is zero
      this.hh = this.querySelector('[data-cd-hh]');
      this.mm = this.querySelector('[data-cd-mm]');
      this.ss = this.querySelector('[data-cd-ss]');
      this.KEY = 'roseCdDeadline';
      this.deadline = this.readDeadline();
      this.tick = this.tick.bind(this);
      this.tick();
      this.timer = setInterval(this.tick, 1000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
    readDeadline() {
      var now = Date.now();
      try {
        var raw = JSON.parse(localStorage.getItem(this.KEY) || 'null');
        if (raw && raw.span === this.span && raw.deadline > now) return raw.deadline;
      } catch (e) {}
      return this.save(now + this.span);
    }
    save(deadline) {
      try { localStorage.setItem(this.KEY, JSON.stringify({ deadline: deadline, span: this.span })); } catch (e) {}
      return deadline;
    }
    tick() {
      var now = Date.now();
      var left = this.deadline - now;
      if (left <= 0) { this.deadline = this.save(now + this.span); left = this.span; }
      var s = Math.floor(left / 1000);
      var h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
      var p = function (n) { return (n < 10 ? '0' : '') + n; };
      if (this.hh) this.hh.textContent = p(h);
      if (this.mm) this.mm.textContent = p(m);
      if (this.ss) this.ss.textContent = p(sec);
    }
  });
}

/* ---- Before/after comparison slider ---- */
if (!customElements.get('rose-cl-slider')) {
  customElements.define('rose-cl-slider', class extends HTMLElement {
    connectedCallback() {
      this.range = this.querySelector('[data-cl-slider-range]');
      this.after = this.querySelector('[data-cl-slider-after]');
      this.divider = this.querySelector('[data-cl-slider-divider]');
      if (!this.range) return;
      var self = this;
      this.apply(this.range.value);
      // Keep the native range for keyboard focus / arrow keys.
      this.range.addEventListener('input', function () { self.apply(self.range.value); });

      // Drag from ANYWHERE on the image (touch + mouse), not just the invisible
      // thumb. This is what makes it work on mobile - the native range only lets
      // you tap-to-jump or drag the thumb you cannot see.
      this.dragging = false;
      this.addEventListener('pointerdown', function (e) {
        self.dragging = true;
        try { self.setPointerCapture(e.pointerId); } catch (_) {}
        self.moveTo(e.clientX);
        e.preventDefault();
      });
      this.addEventListener('pointermove', function (e) {
        if (self.dragging) { self.moveTo(e.clientX); e.preventDefault(); }
      });
      var end = function (e) { self.dragging = false; try { self.releasePointerCapture(e.pointerId); } catch (_) {} };
      this.addEventListener('pointerup', end);
      this.addEventListener('pointercancel', end);
    }
    moveTo(clientX) {
      var r = this.getBoundingClientRect();
      if (!r.width) return;
      var pct = ((clientX - r.left) / r.width) * 100;
      pct = Math.max(0, Math.min(100, pct));
      if (this.range) this.range.value = pct;
      this.apply(pct);
    }
    apply(val) {
      var pct = Math.max(0, Math.min(100, parseFloat(val) || 0)) + '%';
      this.style.setProperty('--cl-split', pct);
      if (this.after) this.after.style.clipPath = 'inset(0 0 0 ' + pct + ')';
      if (this.divider) this.divider.style.left = pct;
    }
  });
}

/* ---- Two-product "add both" bundle ---- */
if (!customElements.get('rose-cl-duo')) {
  customElements.define('rose-cl-duo', class extends HTMLElement {
    connectedCallback() {
      this.data = { a: this.readJson('a'), b: this.readJson('b') };
      this.sel = { a: (this.data.a[0] || null), b: (this.data.b[0] || null) };
      this.idInput = this.querySelector('[data-duo-id]');
      this.lineA = this.querySelector('[data-duo-line="a"]');
      this.lineB = this.querySelector('[data-duo-line="b"]');
      this.totalEl = this.querySelector('[data-duo-total]');
      this.compareEl = this.querySelector('[data-duo-compare]');
      // Merchant typed a fixed bundle price -> never recompute it from the variants.
      this.customTotal = this.hasAttribute('data-duo-customtotal');
      this.bind('a'); this.bind('b');
      this.refresh();
    }
    readJson(key) {
      var el = this.querySelector('[data-duo-variants="' + key + '"]');
      try { return el ? JSON.parse(el.textContent) : []; } catch (e) { return []; }
    }
    find(key, id) {
      var list = this.data[key] || [];
      for (var i = 0; i < list.length; i++) if (String(list[i].id) === String(id)) return list[i];
      return null;
    }
    bind(key) {
      var self = this;
      var sel = this.querySelector('[data-duo-select="' + key + '"]');
      if (!sel) return;                                   // single-variant product: nothing to pick
      var init = this.find(key, sel.value);
      if (init) self.sel[key] = init;
      sel.addEventListener('change', function () {
        var v = self.find(key, sel.value);
        if (!v) return;
        self.sel[key] = v;
        var img = self.querySelector('[data-duo-img="' + key + '"]');
        if (img && v.image) img.src = v.image;
        self.refresh();
      });
    }
    money(str) { return Number(String(str).replace(/[^0-9.]/g, '')) || 0; }
    fmt(n) { return '$' + n.toFixed(2); }
    refresh() {
      var a = this.sel.a, b = this.sel.b; if (!a || !b) return;
      if (this.lineA) this.lineA.value = String(a.id);
      if (this.lineB) this.lineB.value = String(b.id);
      if (this.idInput) this.idInput.value = String(a.id) + ',' + String(b.id);
      if (this.customTotal) return;                       // fixed price typed by the merchant - leave it
      var total = this.money(a.price) + this.money(b.price);
      var comp = this.money(a.compare) + this.money(b.compare);
      if (this.totalEl) this.totalEl.textContent = this.fmt(total);
      if (this.compareEl) { if (comp > total) { this.compareEl.textContent = this.fmt(comp); this.compareEl.hidden = false; } else { this.compareEl.hidden = true; } }
    }
  });
}

/* ---- Estimated delivery + IP geolocation ---- */
if (!customElements.get('rose-cl-delivery')) {
  customElements.define('rose-cl-delivery', class extends HTMLElement {
    connectedCallback() {
      this.locEl = this.querySelector('[data-cl-deliv-loc]');
      this.datesEl = this.querySelector('[data-cl-deliv-dates]');
      this.showState = this.dataset.showState === 'true';
      this.renderDates();
      this.geolocate();
    }
    renderDates() {
      if (!this.datesEl) return;
      var min = parseInt(this.dataset.min, 10) || 5, max = parseInt(this.dataset.max, 10) || 8;
      if (max < min) max = min;
      var f = function (days) {
        var d = new Date(); d.setDate(d.getDate() + days);
        return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
      };
      this.datesEl.textContent = f(min) + ' - ' + f(max);
    }
    setLoc(text) { if (this.locEl && text) this.locEl.textContent = text; }
    geolocate() {
      var self = this;
      var KEY = 'roseGeoLoc';
      // cached for a day
      try {
        var c = JSON.parse(localStorage.getItem(KEY) || 'null');
        if (c && c.exp > Date.now()) { self.setLoc(self.format(c.data)); return; }
      } catch (e) {}
      if (!('fetch' in window)) return;
      fetch('https://get.geojs.io/v1/ip/geo.json', { credentials: 'omit' })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          try { localStorage.setItem(KEY, JSON.stringify({ data: d, exp: Date.now() + 86400000 })); } catch (e) {}
          self.setLoc(self.format(d));
        })
        .catch(function () { /* keep the fallback location */ });
    }
    format(d) {
      if (!d) return null;
      var country = d.country || '';
      var cc = (d.country_code || '').toUpperCase();
      var region = d.region || '';
      // Only trust state for the US; hide it otherwise or when turned off.
      if (this.showState && cc === 'US' && region) return region + ', ' + (country || 'United States');
      return country || null;
    }
  });
}

/* ---- TrustPilot-style review slider + click-to-expand modal ---- */
if (!customElements.get('rose-cl-reviews-slider')) {
  customElements.define('rose-cl-reviews-slider', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-rev-track]');
      this.modal = this.querySelector('[data-rev-modal]');
      var self = this;
      var prev = this.querySelector('[data-rev-prev]'), next = this.querySelector('[data-rev-next]');
      if (prev) prev.addEventListener('click', function () { self.scrollBy(-1); });
      if (next) next.addEventListener('click', function () { self.scrollBy(1); });
      this.querySelectorAll('[data-rev-card]').forEach(function (c) {
        c.addEventListener('click', function () { self.open(c); });
      });
      this.querySelectorAll('[data-rev-close]').forEach(function (b) {
        b.addEventListener('click', function () { self.close(); });
      });
      this._esc = function (e) { if (e.key === 'Escape') self.close(); };
    }
    scrollBy(dir) {
      if (!this.track) return;
      var card = this.track.querySelector('[data-rev-card]');
      var step = card ? card.offsetWidth + 16 : 280;
      this.track.scrollBy({ left: dir * step * 1.2, behavior: 'smooth' });
    }
    starsHtml(n) {
      n = parseInt(n, 10) || 5; var h = '';
      for (var i = 1; i <= 5; i++) h += '<span class="rose-cl-rev__star' + (i <= n ? ' is-on' : '') + '">★</span>';
      return h;
    }
    open(card) {
      if (!this.modal) return;
      var d = card.dataset;
      var q = function (sel) { return this.modal.querySelector(sel); }.bind(this);
      q('[data-rev-modal-name]').textContent = d.name || '';
      var ver = q('[data-rev-modal-verified]'); if (ver) ver.hidden = (d.verified !== 'true');
      q('[data-rev-modal-stars]').innerHTML = this.starsHtml(d.stars);
      q('[data-rev-modal-date]').textContent = d.date || '';
      q('[data-rev-modal-quote]').textContent = d.quote || '';
      var av = q('[data-rev-modal-avatar]');
      if (av) { if (d.avatar) { av.src = d.avatar; av.hidden = false; } else { av.hidden = true; } }
      var media = q('[data-rev-modal-media]');
      if (media) {
        if (d.mediaType === 'video' && d.mediaVideo) {
          media.innerHTML = '<video src="' + d.mediaVideo + '" autoplay muted loop playsinline controls></video>';
          media.hidden = false;
        } else if (d.mediaType === 'image' && d.mediaSrc) {
          media.innerHTML = '<img src="' + d.mediaSrc + '" alt="">';
          media.hidden = false;
        } else { media.innerHTML = ''; media.hidden = true; }
      }
      this.modal.hidden = false;
      document.addEventListener('keydown', this._esc);
      document.body.style.overflow = 'hidden';
    }
    close() {
      if (!this.modal) return;
      var media = this.modal.querySelector('[data-rev-modal-media]');
      if (media) media.innerHTML = '';  // stop any playing video
      this.modal.hidden = true;
      document.removeEventListener('keydown', this._esc);
      document.body.style.overflow = '';
    }
  });
}

/* ===== Quantity-break benefit tooltip popup ===== */
(function () {
  if (window.__roseClQbTip) return;
  window.__roseClQbTip = true;

  function closePop(pop) {
    if (!pop) return;
    pop.hidden = true;
    var body = pop.querySelector('[data-cl-tip-body]');
    if (body) body.innerHTML = '';
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    // open
    var btn = e.target.closest('[data-cl-tip-btn]');
    if (btn) {
      e.preventDefault();
      var tpl = btn.parentNode.querySelector('template[data-cl-tip-data]');
      var scope = btn.closest('[data-cl-bundle]') || document;
      var pop = scope.querySelector('[data-cl-tip-pop]') || document.querySelector('[data-cl-tip-pop]');
      if (!pop || !tpl) return;
      var body = pop.querySelector('[data-cl-tip-body]');
      if (body) body.innerHTML = tpl.innerHTML;
      pop.hidden = false;
      document.body.style.overflow = 'hidden';
      return;
    }
    // close via X or backdrop
    if (e.target.closest('[data-cl-tip-close]')) {
      closePop(e.target.closest('[data-cl-tip-pop]'));
      return;
    }
    if (e.target.hasAttribute && e.target.hasAttribute('data-cl-tip-pop')) {
      closePop(e.target);
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var open = document.querySelector('[data-cl-tip-pop]:not([hidden])');
      if (open) closePop(open);
    }
  });
})();
